/* aq-pin.js — 2026-10-27 (Claude). Journal "Save to Pinterest" button, top-right of photos.
   Replaces the hover button from the Pinterest widget script, which always sits top-left and covered the category badges.
   Desktop: appears on hover over post photos, article cards and product tiles. Touch screens: always visible on post photos only
   (cards are links, so they stay clean). Opens Pinterest's own Save dialog in a small window; no third-party script is loaded. */
(function () {
  'use strict';
  var FRAMES = '.aqg .aqg-heroimg, .aqj-frame, .article-item__image-wrapper, .aqg-ptile__frame';
  var hover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z"/></svg>';

  function bigSrc(img) {
    var s = img.currentSrc || img.src || '';
    if (s.indexOf('//') === 0) s = 'https:' + s;
    return s.replace(/([?&])width=\d+/, '$1width=1200');
  }
  function save(frame) {
    var img = frame.querySelector('img'); if (!img) return;
    var link = frame.closest('a[href]');
    var url = link ? new URL(link.getAttribute('href'), location.href).href : location.href.split('#')[0];
    var desc = img.getAttribute('data-pin-description') || img.getAttribute('alt') || document.title;
    var pin = 'https://www.pinterest.com/pin/create/button/?url=' + encodeURIComponent(url) +
      '&media=' + encodeURIComponent(bigSrc(img)) + '&description=' + encodeURIComponent(desc);
    window.open(pin, 'aq-pin', 'width=750,height=640,menubar=no,toolbar=no,resizable=yes,scrollbars=yes');
  }
  function add(frame) {
    if (!frame || frame.querySelector(':scope > .aq-pin')) return;
    var img = frame.querySelector('img');
    if (!img || frame.getBoundingClientRect().width < 150) return;
    var b = document.createElement('span');
    b.className = 'aq-pin'; b.setAttribute('role', 'button'); b.setAttribute('tabindex', '0');
    b.setAttribute('aria-label', 'Save to Pinterest'); b.innerHTML = ICON;
    var go = function (e) { e.preventDefault(); e.stopPropagation(); save(frame); };
    b.addEventListener('click', go);
    b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') go(e); });
    frame.classList.add('aq-pin-host');
    frame.appendChild(b);
  }
  if (hover) {
    document.addEventListener('mouseover', function (e) {
      var f = e.target.closest && e.target.closest(FRAMES);
      if (f) add(f);
    }, { passive: true });
  } else {
    var run = function () { Array.prototype.forEach.call(document.querySelectorAll('.aqg .aqg-heroimg'), add); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    window.addEventListener('load', run);
  }
})();
